'use strict';

module.exports = function (ngModule)
{
    require('./main')(ngModule);
    require('./applications')(ngModule);
    require('./files')(ngModule);
    require('./anomalies')(ngModule);
    require('./general_network')(ngModule);
    require('./ioc_notifications')(ngModule);
    require('./search')(ngModule);
    require('./stealth')(ngModule);
    require('./survey')(ngModule);
    require('./system_events')(ngModule);
    require('./users')(ngModule);
    require('./feeds')(ngModule);
    require('./hunting')(ngModule);
    require('./hybrid_alerts')(ngModule);
}



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/index.js
 **/